import styles from './SuccessView.module.css';
import { Button } from '#/components/Button';

const SUCCESS_IMAGE = `${import.meta.env.VITE_ASSETS_URL}/assets/images/change_success.png`;

type Props = {
  schoolName: string;
  studentNumber: string;
  schoolEmail: string;
  onLogout: () => void;
};

function Field({ label, value }: { label: string; value: string }) {
  return (
    <div className={styles.field}>
      <span className={styles.fieldLabel}>{label}</span>
      <span className={styles.fieldValue}>{value}</span>
    </div>
  );
}

export function SuccessView({ schoolName, studentNumber, schoolEmail, onLogout }: Props) {
  return (
    <div className={styles.card}>
      <img className={styles.image} src={SUCCESS_IMAGE} alt="" />
      <h1 className={styles.title}>生徒用アカウントとして設定されています</h1>
      <p className={styles.description}>あなたのZEN IDアカウントは、以下の生徒情報に紐づいて登録されています。</p>
      <div className={styles.fields}>
        <Field label="校内メールアドレス" value={schoolEmail} />
        <Field label="学籍番号" value={studentNumber} />
        <Field label="所属校" value={schoolName} />
      </div>
      <Button variant="secondary" onClick={onLogout}>
        ログアウトして終了
      </Button>
    </div>
  );
}
